var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ManageServiceType"}},[_c('ServiceType',{attrs:{"AllowEdit":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }